import { TableCell, TableRow } from "@mui/material";
import { useTheme } from '@mui/material/styles';

const CohortStatsTableRow = (props) => {
    const {
        index,
        hypotheses,
        insights,
        interviews,
        invalidatedHypotheses,
        teamName,
        validatedHypotheses,
        week_chart,
        columns,
    } = props;
    const teamNameCell = columns[0]?.Cell;
    const weekChartCell = columns[1]?.Cell;
    const theme = useTheme();

    return (
        <TableRow
            sx={{
                ".MuiTableCell-root, .MuiSvgIcon-root": {
                    color: "#828282",
                },
                "&:nth-of-type(even)": {
                    backgroundColor: theme?.custom?.tableAlternateBG,
                },
            }}
        >
            <TableCell
                sx={{
                    width: "30%",
                }}
            >
                {teamNameCell ? teamNameCell(teamName) : "teamName"}
            </TableCell>
            <TableCell align="center">
                {weekChartCell ? weekChartCell(week_chart) : "N/A"}
            </TableCell>
            <TableCell align="center">{interviews}</TableCell>
            <TableCell align="center">{insights}</TableCell>
            <TableCell align="center">{hypotheses}</TableCell>
            <TableCell align="center">{validatedHypotheses}</TableCell>
            <TableCell align="center">{invalidatedHypotheses}</TableCell>
        </TableRow>
    );
};

export default CohortStatsTableRow;
